import { useEncampyLaunchData } from "../../hooks/useEncampyLaunchData";
import { getEPlanNavigateToPaymentAutomation } from "../../util/encampy/ePlanNavigateToPayment";
import {
  EncampyAutomationLauncher,
  EncampyAutomationLauncherProps,
} from "./AutomationLauncher";

export interface EncampyEPlanPaymentLauncherProps
  extends Omit<EncampyAutomationLauncherProps, "launchData"> {
  username: string;
  password: string;
  reportingYear: number;
  portalReportId?: string;
  invoiceNumber?: string;
}

export function EncampyEPlanPaymentLauncher({
  username,
  password,
  reportingYear,
  portalReportId,
  invoiceNumber,
  ...automationLauncherProps
}: EncampyEPlanPaymentLauncherProps) {
  const automatePayment = (() => {
    if (!portalReportId && !invoiceNumber) {
      return null;
    }

    return getEPlanNavigateToPaymentAutomation(
      username,
      password,
      reportingYear,
      portalReportId,
      invoiceNumber
    );
  })();

  const { launchData, isLoading, error } = useEncampyLaunchData(
    "https://tier2.erplan.net",
    automatePayment,
    [username, password, reportingYear, portalReportId, invoiceNumber]
  );

  // If we're still generating launch data, show disabled state
  if (isLoading) {
    return (
      <EncampyAutomationLauncher
        {...automationLauncherProps}
        launchData={{ url: "", tasks: [] }}
        buttonText="Loading..."
        disabled={true}
      />
    );
  }

  // If we have an error generating launch data, show disabled state with error
  if (error || !launchData) {
    const handleErrorClick = () => {
      const errorMessage =
        error || "Failed to generate payment navigation automation";
      automationLauncherProps.onError?.(errorMessage);
    };

    return (
      <EncampyAutomationLauncher
        {...automationLauncherProps}
        launchData={{ url: "", tasks: [] }}
        disabled={true}
        onError={handleErrorClick}
      />
    );
  }

  // Normal case: pass through all props to EncampyAutomationLauncher with generated launch data
  return (
    <EncampyAutomationLauncher
      {...automationLauncherProps}
      launchData={launchData}
    />
  );
}
